<template>
  <div>
    <div class="ibox animated fadeInRightBig">
      <div class="ibox-title">
        <h3>
          {{ (operation === "post" ? "Novo" : "Editar") + " " + modelName }}
          <i :class="'fa ' + icon" style="float: right; font-size: 21px; margin-top: -5px"></i>
        </h3>
      </div>
      <form id="form">
        <div class="ibox-content">
          <div class="row">
            <div class="form-group col-md-12" v-if="model.photo">
              <div class="text-center m-b-lg">
                <img :src="model.photo" style="max-width: 240px; max-height: 340px" />
              </div>
            </div>
            <div class="form-group col-md-6">
              <label for="title"><span class="required">*</span> Título</label>
              <input type="text" class="form-control" name="title" maxlength="191" v-model="model.title" id="title" />
            </div>
            <div class="form-group col-md-6">
              <label for="theme_category_id"><span class="required">*</span> Categoria de Tema</label>
              <select class="form-control" v-model="model.theme_category_id" id="theme_category_id">
                <option value="" disabled selected>Selecione...</option>
                <option :value="category.id" v-for="(category, index) in themeCategories" :key="index">
                  {{ category.description }}
                </option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label for="team_id">Áreas de aplicação</label>
              <v-select :options="teams" label="name" v-model="selectedTeams" multiple></v-select>
              <div class="btn btn-primary" style="margin-top:5px" @click="selectAllTeams">Selecionar Todos</div>
            </div>
            <div class="col-md-6">
              <label for="active_status">Ativar/Inativar</label>
              <br> <!-- Adicione uma quebra de linha para separar o rótulo do checkbox -->
              <input type="checkbox" v-model="model.active_status" name="check" style="margin-top: 2%;"
                id="active_status" />
            </div>
          </div>
          <!-- <div @click="showGPT = !showGPT" class="btn btn-success"> GPT </div> -->
          <div class="col-md-12 gpt-box">
            <h3>Assistente IA
              <div class="btn btn-danger beta-button" type="button" data-toggle="popover"
                title="Olá, usuários do DDS Digital!"
                data-html="true"
                data-content="
                  <p>Estamos animados em apresentar nossa mais recente funcionalidade em beta de Geração de temas com IA. 
                  Durante este período de testes, estamos oferecendo acesso gratuito a todos os nossos usuários. 
                  Queremos que você experimente e nos ajude a aprimorar essa novidade.</p> 
                  <p><strong>Feedback:</strong> Sua opinião é essencial para nós! Por favor, envie-nos seu feedback, sugestões e relatos de problemas que encontrar durante 
                  o uso da funcionalidade em beta. Juntos, podemos torná-la ainda melhor!</p> 
                  <p><strong>Fim do Período Beta:</strong> Após o período de teste, a funcionalidade 
                  estará disponível apenas para clientes que optarem por contratar um pacote que dará direito ao uso. Se você deseja continuar usando 
                  essa funcionalidade, entre em contato conosco para saber mais sobre nossos planos e benefícios.</p> 
                  <p>Agradecemos por fazer parte deste importante momento de evolução do nosso aplicativo!</p>">
                <strong>BETA</strong></div>
            </h3>
            <input @keyup.enter="requestOpenAI()" placeholder="Faça uma solicitação ..." class="form-control"
              v-model="aiPrompt" style="margin-bottom:10px;">
            <div class="row centered" style="margin-left:50%" v-if="aiLoading">
              <span class="fa fa-spinner fa-spin fa-4x"></span>
            </div>
            <div @click="requestOpenAI()" v-if="!aiLoading" :class="{ 'send-button': aiPrompt, 'empty-button': aiPrompt == '' }"><span
                data-state="closed">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="text-white dark:text-black arrow">
                  <path d="M7 11L12 6L17 11M12 18V7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
                </svg></span>
            </div></input>
            <textarea v-if="!aiLoading" style="height:150px;" placeholder="Como posso te ajudar hoje?"
              class="form-control" v-model="aiResponse"></textarea>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="summary"><span class="required"></span> Resumo</label>
              <vue-editor name="summary" id="summary" v-model="model.summary" />
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="photo"><span v-if="id == ''" class="required"></span>
                    Foto:</label>

                  <div v-if="model.photo && !imgUrl">
                    <a :href="model.photo" data-toggle="tooltip" target="_blank">
                      <img :src="model.photo" class="col-md-12 pictureSize" />
                    </a>
                  </div>

                  <div v-if="imgUrl">
                    <img :src="imgUrl" class="col-md-12 pictureSize" />
                  </div>

                  <input type="file" name="photo" v-on:change="fileChanged" id="photo" class="form-control" />
                </div>
                <div class="form-group col-md-6">
                  <label for="document"><span v-if="id == ''"></span>
                    Documento:</label>
                  <label v-if="model.document">(clique na imagem para abrir)</label>

                  <div v-show="model.document && model.id">
                    <a :href="model.document" data-toggle="tooltip" target="_blank">
                      <img :src="pdfUrl" class="col-md-12 pictureSize" />
                    </a>
                  </div>
                  <div v-show="model.document && !model.id">
                    <img :src="pdfUrl" class="col-md-12 pictureSize" />
                  </div>

                  <input type="file" name="document" id="document" v-on:change="onDocumentChange"
                    accept="application/pdf" class="form-control" />
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="question"> Perguntas:</label>
                  <div v-show="model.question && model.id">
                    <a :href="model.question" data-toggle="tooltip" target="_blank">
                      <img :src="pdfUrl" class="col-md-12 pictureSize" />
                    </a>
                  </div>
                  <div v-show="model.question && !model.id">
                    <img :src="pdfUrl" class="col-md-12 pictureSize" />
                  </div>

                  <input type="file" name="question" id="question" accept="application/pdf" class="form-control"
                    v-on:change="onQuestionChange" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="pull-right">
            <router-link :to="backUrl" class="btn btn-info" :class="{ 'disabled': saveLoading }">
              <i class="fa fa-arrow-left"></i> Voltar
            </router-link>
            <a class="btn btn-success" @click="save" :disabled="saveLoading">
              <span v-if="saveLoading">
                <i class="fa fa-spinner fa-spin"></i> Salvando...
              </span>
              <span v-else>
                Salvar <i class="fa fa-save"></i>
              </span>
            </a>
          </div>
          <p><span class="required">*</span> Campos Obrigatórios</p>
          <div class="clearfix"></div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import env from "../../../config/env"

export default {
  data() {
    return {
      showGPT: false,
      aiPrompt: '',
      aiResponse: '',
      aiLoading: false,
      saveLoading: false,
      selectedTeams: [],
      teams: [],
      model: {
        title: "",
        summary: "",
        photo: "",
        document: "",
        theme_category_id: "",
        special: "",
        question: "",
        active_status: true,
      },
      pdfUrl: this.$store.state.url + "img/defaults/pdf.png",
      imgUrl: null,
      themeCategories: [],
    };
  },
  props: {
    modelName: String,
    saveUrl: String,
    operation: String,
    id: String,
    backUrl: String,
    icon: String,
  },
  methods: {
    selectAllTeams(event) {
      event.preventDefault();
      this.selectedTeams = [...this.teams];
    },
    fileChanged: function (e) {
      const file = e.target.files[0];
      if (!file) this.imgUrl = null;
      else this.imgUrl = URL.createObjectURL(file);
    },
    async requestOpenAI() {
      this.aiResponse = 'Gerando Resposta ...';
      this.aiLoading = true;
      const self = this;
      
      try {
        const response = await self.$http.post(
          self.$store.state.api + 'gpt/generate-text',
          { prompt: self.aiPrompt }
        );
        
        self.aiResponse = response.data.data;
        this.aiLoading = false;
      } catch (error) {
        this.aiLoading = false;
        console.error('Erro na requisição IA:', error);
        self.$message(null, "Ocorreu um erro ao gerar o texto com IA", "error");
      }

      this.saveGptLog();
    },
    saveGptLog() {
      const self = this;
      const api = self.$store.state.api + 'saveGptLog/'

      let fd = new FormData();

      fd.append("userPrompt", self.aiPrompt);
      fd.append("gptResponse", self.aiResponse);

      self.$http
        .post(api, fd)
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    save: function () {
      const self = this;
      
      // Evita múltiplos cliques durante o loading
      if (self.saveLoading) return;
      
      self.saveLoading = true;
      const api = self.$store.state.api + self.saveUrl + self.id;

      let form = new FormData();
      let photo = document.getElementById("photo");
      let documentFile = document.getElementById("document");
      let questionFile = document.getElementById("question");

      form.append("title", self.model.title);
      form.append("summary", self.model.summary);
      form.append("theme_category_id", self.model.theme_category_id);
      form.append("active_status", self.model.active_status ? '1' : '0');
      form.append("photo", photo.files[0] ? photo.files[0] : "");
      form.append(
        "document",
        documentFile.files[0] ? documentFile.files[0] : ""
      );
      form.append(
        "question",
        questionFile.files[0] ? questionFile.files[0] : ""
      );
      form.append("special", self.model.special ? 1 : 0);

      self.selectedTeams.forEach(function (team) {
        form.append("selectedTeams[]", team.id)
      });

      let validation = false;

      if (self.id) {
        form.append("_method", "PUT");
        if (!self.model.document && !self.model.summary) {
          self.$message(
            null,
            "O Tema precisa ter pelo menos um resumo OU um documento",
            "error"
          );
          self.saveLoading = false;
          return
        }
      }

      self.$http[self.$props.operation](api, form)
        .then((response) => {
          self.$message(
            null,
            `${self.modelName} ${!self.id ? "cadastrado" : "atualizado"
            } com sucesso!`,
            "success"
          );
          self.saveLoading = false;
          self.$router.push(self.backUrl);
        })
        .catch((error) => {
          self.saveLoading = false;
          self.$error(error);
        });


    },
    getModel() {
      const self = this;
      const api = self.$store.state.api + self.saveUrl + self.id + '?with[]=teams';

      self.$http
        .get(api)
        .then((response) => {
          self.model = response.data.data[0];
          if (self.model.summary == "<p>null</p>" || self.model.summary == "null") {
            self.model.summary = ''
          }
          self.selectedTeams = self.model.teams;
        })
        .catch((error) => {
          self.$message(
            null,
            "Ocorreu um erro ao buscar as informações",
            "error"
          );
        });
    },
    getThemeCategories() {
      const self = this;
      const api =
        self.$store.state.api +
        "theme-categories?paginated=false&orderByAsc=description";

      self.$http
        .get(api)
        .then((response) => {
          self.themeCategories = response.data.data;
        })
        .then(() => {
          if (self.id) {
            // Só pode carregar a model principal, após o combobox de categoria estar preenchido
            self.getModel();
          }
        })
        .catch((error) => {
          self.$message(
            null,
            "Ocorreu um erro ao buscar as informações",
            "error"
          );
        });
    },
    getTeams() {
      const self = this;
      const api =
        self.$store.state.api + "teams?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.teams = response.data.data;
        })
        .catch((error) => {
          self.$message(
            null,
            "Ocorreu um erro ao buscar as informações",
            "error"
          );
        });
    },
    onDocumentChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        if (!this.model.id) this.model.document = null;
        return;
      }
      this.document = files[0];
      this.model.document = files[0];
    },
    onQuestionChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        if (!this.model.id) this.model.question = null;
        return;
      }
      this.model.question = files[0];
    },
  },
  components: {
    VueEditor
  },
  mounted() {
    this.getTeams();
    this.getThemeCategories();

    $(function () {
      $('[data-toggle="popover"]').popover()
    })
  },
};
</script>
<style>
.popover {
  max-width: 600px
}
</style>
<style scoped>
.pictureSize {
  max-width: 85px;
  max-height: 112px;
}

.gpt-box {
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-radius: 6px;
  padding: 10px;
  border-color: lightgray;
}

.send-button {
  position: absolute;
  top: 20%;
  right: 2rem;
  border-radius: 6px;
  border: 1px solid black;
  background-color: black;
  color: #fff;
  transition-duration: 0.3s;
  cursor: pointer;
  margin-top: 4px;
}

.beta-button {
  font-size: 13px;
  padding: 3px;
}

.empty-button {
  position: absolute;
  top: 20%;
  right: 2rem;
  border-radius: 6px;
  /* 6px */
  color: #8c8c8c;
  /* gray */
  border-color: #8c8c8c;
  background-color: #8c8c8c;
  opacity: 0.1;
  cursor: not-allowed;
  transition-duration: 0.3s;
  cursor: pointer;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Theme/FormSave.vue